import React from "react";
import { CheckCircle2 } from "lucide-react";
import { STATS, IMAGES } from "../mock/mock";

const STRENGTHS = [
  "12+ years of manufacturing excellence",
  "Large-scale production capacity",
  "Strict quality assurance at every stage",
  "Custom manufacturing for any specification",
  "Pan-India logistics and on-time delivery",
  "Dedicated B2B account management",
];

export default function About() {
  return (
    <div className="bg-white">
      <section className="bg-[#f7f9fc] py-9">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <p className="text-[12px] font-semibold tracking-[0.25em] text-[#f4520b] mb-3">ABOUT US</p>
          <h1 className="font-heading text-4xl font-extrabold text-[#1c2e3a]">Supplying Comfort at Scale</h1>
          <p className="mt-4 text-slate-600 max-w-2xl">mattressDIRECT.in is a trusted B2B mattress manufacturer and supplier, helping businesses across India furnish spaces with reliable, high-quality bedding - better sleep, direct to you.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <img src={IMAGES.warehouse} alt="Our facility" className="rounded-xl shadow-xl object-cover w-full aspect-[5/4]" />
          <div>
            <h2 className="font-heading text-3xl font-extrabold text-[#1c2e3a]">Why Businesses Choose Us</h2>
            <ul className="mt-6 space-y-3.5">
              {STRENGTHS.map((s) => (
                <li key={s} className="flex items-start gap-3 text-[15px] text-slate-700"><CheckCircle2 size={20} className="text-[#1c2e3a] mt-0.5 shrink-0" /> {s}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-[#f7f9fc] py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-4xl md:text-5xl font-extrabold text-[#1c2e3a]">{s.value}</p>
              <p className="mt-2 text-slate-500 text-[14px] font-medium">{s.label}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
